import Skeleton from '@mui/material/Skeleton'

const cards = Array.from({ length: 8 }, (_, i) => i)

export const SearchLoadingCard = () => {
  return (
    <div className="location-search-card group relative overflow-hidden rounded-2xl border border-ink-100/15 bg-white-500">
      <div className="flex h-[142px] md:h-[160px] card-stacked:h-auto card-stacked:flex-col">
        {/* Mirrors the real card's image step (`lg:`, not `md:`) so the
            skeleton doesn't reflow into a different shape on load. */}
        <div className="relative w-[130px] shrink-0 overflow-hidden sm:w-[155px] lg:w-[200px] card-stacked:aspect-[16/9] card-stacked:w-full">
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </div>

        <div className="flex flex-1 flex-col justify-between p-3 md:p-4">
          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <Skeleton height={16} width="55%" className="md:!h-5" />
              <Skeleton variant="circular" className="size-3.5 shrink-0" />
            </div>
            <Skeleton height={12} width="75%" className="mt-1 md:!h-4" />
          </div>

          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-1">
              <Skeleton variant="circular" className="size-3.5" />
              <Skeleton height={12} width={28} className="md:!h-4" />
              <span className="text-xs text-ink-200 md:text-sm">•</span>
              <Skeleton height={12} width={56} className="md:!h-4" />
            </div>
            <div className="shrink-0 rounded-lg bg-cream-300 px-2 py-0.5 md:px-2.5 md:py-1">
              <Skeleton height={12} width={42} className="md:!h-4" />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <Skeleton height={22} width={96} className="md:!h-7" />
            <Skeleton height={18} width={48} className="rounded-lg md:!h-6" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default function LoadingCards() {
  return (
    <div className="mt-2 mb-6 flex flex-col gap-5 px-3 md:mt-6 md:mb-0">
      {cards.map((index) => (
        <SearchLoadingCard key={index} />
      ))}
    </div>
  )
}
